import { STORAGE_KEYS } from '@/platform/auth-runtime/token-storage';
import { deleteCookie, getCookie, setCookie } from '@/shared/utils/cookie';
import { isPrivateLink, toPrivateLinkHref } from '@/shared/utils/private-link';

// Cross-domain cookie contract with the public-domain writer:
//   x-sr-aid===<accountId>&&&x-sr-token===<token>&&&x-sr-ubid===<ubid>
const ENTRY_SEPARATOR = '&&&';
const KV_SEPARATOR = '===';

// Any host under the parent `celerdata.com` domain can write the cookie, so only
// these keys may reach localStorage.
const ALLOWED_KEYS: readonly string[] = [STORAGE_KEYS.aid, STORAGE_KEYS.token, STORAGE_KEYS.ubid];

// Must run before the host fetches the user, or `fetchInfo()` misses the ubid
// and the user is bounced to `/login`.
export function drainPrivateLinkLoginCookies(): void {
  if (!getCookie('privateLinkLogin') || !isPrivateLink()) return;
  const result = getCookie('privateLinkLoginResult');
  if (result) {
    for (const item of result.split(ENTRY_SEPARATOR)) {
      if (!item) continue;
      const [k, v] = item.split(KV_SEPARATOR);
      if (k && v && ALLOWED_KEYS.includes(k)) localStorage.setItem(k, v);
    }
  }
  deleteCookie('privateLinkLogin');
  deleteCookie('privateLinkLoginResult');
}

// On the public domain, pack the session into the parent-domain cookie and
// redirect to the private-link host. Returns true when it redirected.
export function handOffToPrivateLink(): boolean {
  if (!getCookie('privateLinkLogin') || isPrivateLink()) return false;

  const payload = ALLOWED_KEYS.map(
    (key) => `${key}${KV_SEPARATOR}${localStorage.getItem(key)}`,
  ).join(ENTRY_SEPARATOR);
  setCookie('privateLinkLoginResult', payload, 1);

  location.assign(toPrivateLinkHref(location.href));
  return true;
}
